import I18n from "i18n-js";

I18n.translations = {
  es: { // Español (Fuente)
    from: "Desde",
    home_collections: {
      home_reviews: "350+ personas al año viajan con Outdoor Index",
      find_your_experience: "Busca tu excursión",
      carousel_region: "Aventuras por región",
      carousel_activities: "Aventuras por actividades",
      carousel_time_preference: "Aventuras por preferencia de tiempo",
      "sub-landing": "Descubre las mejores opciones turísticas en Chile con Outdoor Index. Compara y explora una amplia variedad de programas desde Atacama hasta la Patagonia. ¡Reserva hoy para vivir experiencias únicas!",
      title: "Tours de aventura en Chile y Patagonia",
      subtitle: "Encuentra aventuras con los mejores guías locales"
    },
    guidebook: {
      download_our_guide_book: "Descarga nuestro libro guía y comienza tu viaje con Outdoor Index",
      find_out_everything: "Entérate de todo sobre la Patagonia Chilena Sur."
    },
    reviews: {
      title: "Reseñas",
      more: "Más",
      reviewing_excursion: "Deja tu reseña",
      thanks_for_submitting: "Gracias por tu reseña",
      review: "Reseña",
      footer: "Ver en TrustPilot"
    },
    home: {
      site_title: "Outdoor Index: Reserva tours de aventura en Patagonia y Chile",
      things_to_do_in: "Sugerencias en",
      scientific_excursions: "En profundo contacto con la naturaleza",
      luxury_experience: "Vive exclusivo, solo para ti",
      adventure_excursions: "Da más de ti mismo",
      the_best_excursions: "Las mejores excursiones para ésta temporada",
      explore_your_interests: "Explora tus intereses",
      excursions: "Excursiones",
      products: "productos",
      suggestions: "Sugerencias",
      hard_adventurous: "Activos",
      soft_adventurous: "Transformador",
      scientific: "Descubrimiento",
      family: "Grupos",
      luxury: "Sofisticados",
      promotions: "Promocionales",
      download: "Descarga",
      adventures_by_region: "Aventuras por región",
      north_patagonia: "Patagonia Norte",
      south_patagonia: "Patagonia Sur",
      lakes_and_rivers: "Región Lagos y Ríos"
    },
    excursions: {
      title: "Título",
      location: "Lugar",
      zone: "Zona",
      category: "Categoría",
      profiles: "Tipo de viaje",
      price: "Precio (en dólares)",
      usd_price: "Precio (en dólares)",
      clp_price: "Precio (en pesos)",
      vacancies: "Cupos",
      duration: "Duración",
      half_day: "Medio día",
      full_day: "Día completo",
      multiple_days: "Varios días",
      duration_days: "Días",
      duration_hours: "Horas",
      itinerary: {
        title: "Título",
        sub_title: "Subtítulo",
        body: "Cuerpo"
      },
      faq: {
        title: "Título",
        sub_title: "Subtítulo",
        body: "Cuerpo"
      },
      days: {
        zero: "Día",
        one: "Día",
        other: "Días"
      },
      hours: {
        zero: "Hora",
        one: "Hora",
        other: "Horas"
      },
      "add_images_(minimum_3)": "Agregar imágenes (mínimo 3)",
      disclaimer: "Disclaimer",
      description: "Visión general",
      body: "Nuestro Itinerario",
      body_old: "Nuestro Itinerario (antiguo)",
      useful_information: "Info de utilidad",
      "what's_included?": "Incluido",
      "what's_not_included?": "No incluido",
      meeting_instruction: "Lugar de partida",
      meeting_address: "Dirección",
      policies: "Políticas de cancelación",
      save_excursion: "Salvar excursión",
      "what_we'll_do": "Visión general",
      our_itinerary: "Itinerario",
      faqs: "FAQs",
      images: "Imágenes",
      edit_excerpt: "Toda la información solicitada para crear el perfil del proveedor es de vital importancia para establecer el vínculo comercial con Outdoor Index. Por favor ingresa la información lo más precisa posible.",
      other_excursions_from_this_tour_company: "Otras experiencias de este proveedor",
      create_excursions: "Crear excursión",
      more: "Más",
      less: "Menos",
      best_excursions_for_the_next_season: "Recomendados para esta temporada",
      add_extras: "Agregar extras",
      price_per_reservations: "Precio por reserva",
      minimum_reservations: "N° pasajeros",
      extra_description: "Actividad",
      mkt_clp_price: "Valor base clp",
      mkt_usd_price: "Valor base usd",
      macro_zone: "Macro Zona",
      meta_title: "Meta título",
      meta_description: "Meta descripción",
      time: "Tiempo",
      prices: "Precios",
      details: "Detalles",
      included: "¿Qué está incluido?",
      locations: "Locación"
    },
    products_show_photos: "Ver (%{n}) fotos",
    ondemand: {
      explanation: "!Excursión exclusiva! contáctate con nuestro especialista en terreno.",
      label: "Privado"
    },
    products_search: {
      activities: "Actividades",
      regions: "Regiones",
      time: "Tiempo",
      date_sub_label: "¿Cuando quieres ir?",
      activities_sub_label: "Escoge tu actividad",
      regions_sub_label: "¿Qué región quieres visitar?",
      time_sub_label: "Selecciona tu preferencia de horario!",
      date: "Fecha",
      all_adventures: "Todas las aventuras",
      search: "Buscar",
      clear: "Limpiar selección",
      tours: "tours",
      subtext: "Explora todos los tours y excursiones disponibles. Planifica tu itinerario, reserva y disfruta de las maravillas de nuestra naturaleza.",
      in: "en"
    },
    searches: {
      no_result_to: 'Perdona, no hay resultados para "%{category_name}" en "%{zone_name}"',
      recommended_for_you: 'Experiencias para hacer en "%{zone_name}"',
      category_products_in_zone: '"%{category_name}" en "%{zone_name}"',
      category_products_in_zone_no_result: 'Perdona, por ahora no hay "%{category_name}" en "%{zone_name}"',
      all_products_in_zone: 'Todos las experiencias en "%{zone_name}"',
      all_products_in_zone_no_result: 'Perdona, no hay experiencias en "%{zone_name}"',
      all_category_products: 'Todas las experiencias de "%{category_name}"',
      all_category_products_no_result: 'Perdona, por ahora no hay experiencias de "%{category_name}"',
      please_select_category_or_zone: "Por favor selecciona una categoría o zona"
    },
    label: "Privado",
    active_admin: {
      landing: {
        more_info: "Más info"
      }
    },
    blog: {
      travel_nature_growth: "Viajes, naturaleza & crecimiento"
    },
    chat: {
      need_help: 'Necesitas ayuda?',
      talk_to_local_guide: 'Habla con un guía local'
    }
  },
  en: { // Inglés
    from: "From",
    home_collections: {
      home_reviews: "350+ people per year travel with Outdoor Index",
      find_your_experience: "Find your excursion",
      carousel_region: "Adventures by region",
      carousel_activities: "Adventures by activities",
      carousel_time_preference: "Adventures by time preference",
      "sub-landing": "Discover the best tourist options in Chile with Outdoor Index. Compare and explore a wide variety of programs from Atacama to Patagonia. Book today to live unique experiences!",
      title: "Adventure tours in Chile and Patagonia",
      subtitle: "Find adventures with the best local guides" // Keeping this instead of the original "Explore nature" to match the 'es' source.
    },
    guidebook: {
      download_our_guide_book: "Download our guide book and start your journey with Outdoor Index",
      find_out_everything: "Find out everything about Southern Chilean Patagonia."
    },
    reviews: {
      title: "Reviews",
      more: "More",
      reviewing_excursion: "Leave your review",
      thanks_for_submitting: "Thanks for your review",
      review: "Review",
      footer: "View on TrustPilot"
    },
    home: {
      site_title: "Outdoor Index: Book adventure tours in Patagonia and Chile",
      things_to_do_in: "Suggestions in",
      scientific_excursions: "In deep contact with nature",
      luxury_experience: "Live exclusive, just for you",
      adventure_excursions: "Give more of yourself",
      the_best_excursions: "The best excursions for this season",
      explore_your_interests: "Explore your interests",
      excursions: "Excursions",
      products: "products",
      suggestions: "Suggestions",
      hard_adventurous: "Active",
      soft_adventurous: "Transformative",
      scientific: "Discovery",
      family: "Groups",
      luxury: "Sophisticated",
      promotions: "Promotional",
      download: "Download",
      adventures_by_region: "Adventures by region",
      north_patagonia: "North Patagonia",
      south_patagonia: "South Patagonia",
      lakes_and_rivers: "Lakes and Rivers Region"
    },
    excursions: {
      title: "Title",
      location: "Place",
      zone: "Zone",
      category: "Category",
      profiles: "Type of trip",
      price: "Price (in dollars)",
      usd_price: "Price (in dollars)",
      clp_price: "Price (in pesos)",
      vacancies: "Spots",
      duration: "Duration",
      half_day: "Half day",
      full_day: "Full day",
      multiple_days: "Multiple days",
      duration_days: "Days",
      duration_hours: "Hours",
      itinerary: {
        title: "Title",
        sub_title: "Subtitle",
        body: "Body"
      },
      faq: {
        title: "Title",
        sub_title: "Subtitle",
        body: "Body"
      },
      days: {
        zero: "Day",
        one: "Day",
        other: "Days"
      },
      hours: {
        zero: "Hour",
        one: "Hour",
        other: "Hours"
      },
      "add_images_(minimum_3)": "Add images (minimum 3)",
      disclaimer: "Disclaimer",
      description: "Overview",
      body: "Our Itinerary",
      body_old: "Our Itinerary (old)",
      useful_information: "Useful info",
      "what's_included?": "Included",
      "what's_not_included?": "Not included",
      meeting_instruction: "Departure point",
      meeting_address: "Address",
      policies: "Cancellation policies",
      save_excursion: "Save excursion",
      "what_we'll_do": "Overview",
      our_itinerary: "Itinerary",
      faqs: "FAQs",
      images: "Images",
      edit_excerpt: "All the requested information to create the provider's profile is vital to establish the commercial link with Outdoor Index. Please enter the information as accurately as possible.",
      other_excursions_from_this_tour_company: "Other experiences from this provider",
      create_excursions: "Create excursion",
      more: "More",
      less: "Less",
      best_excursions_for_the_next_season: "Recommended for this season",
      add_extras: "Add extras",
      price_per_reservations: "Price per reservation",
      minimum_reservations: "No. passengers",
      extra_description: "Activity",
      mkt_clp_price: "Base value clp",
      mkt_usd_price: "Base value usd",
      macro_zone: "Macro Zone",
      meta_title: "Meta title",
      meta_description: "Meta description",
      time: "Time",
      prices: "Prices",
      details: "Details",
      included: "What's included?",
      locations: "Location"
    },
    products_show_photos: "View (%{n}) photos",
    ondemand: {
      explanation: "Exclusive excursion! Contact our specialist on site.",
      label: "Private"
    },
    products_search: {
      activities: "Activities",
      regions: "Regions",
      time: "Time",
      date_sub_label: "When do you want to go?",
      activities_sub_label: "Choose your activity",
      regions_sub_label: "Which region do you want to visit?",
      time_sub_label: "Select your time preference!",
      date: "Date",
      all_adventures: "All adventures",
      search: "Search",
      clear: "Clear selection",
      tours: "tours",
      subtext: "Explore all available tours and excursions. Plan your itinerary, book and enjoy the wonders of our nature.",
      in: "in"
    },
    searches: {
      no_result_to: 'Sorry, no results found for "%{category_name}" in "%{zone_name}"',
      recommended_for_you: 'Experiences to do in "%{zone_name}"',
      category_products_in_zone: '"%{category_name}" in "%{zone_name}"',
      category_products_in_zone_no_result: 'Sorry, for now there are no "%{category_name}" in "%{zone_name}"',
      all_products_in_zone: 'All experiences in "%{zone_name}"',
      all_products_in_zone_no_result: 'Sorry, there are no experiences in "%{zone_name}"',
      all_category_products: 'All experiences of "%{category_name}"',
      all_category_products_no_result: 'Sorry, for now there are no experiences of "%{category_name}"',
      please_select_category_or_zone: "Please select a category or zone"
    },
    label: "Private",
    active_admin: {
      landing: {
        more_info: "More info"
      }
    },
    blog: {
      travel_nature_growth: "Travel, nature & growth"
    },
    chat: {
      need_help: 'Need help?',
      talk_to_local_guide: 'Talk to a local guide'
    }
  },
  pt: { // Portugués
    from: "Desde",
    home_collections: {
      home_reviews: "350+ pessoas por ano viajam com a Outdoor Index",
      find_your_experience: "Procure sua excursão",
      carousel_region: "Aventuras por região",
      carousel_activities: "Aventuras por atividades",
      carousel_time_preference: "Aventuras por preferência de tempo",
      "sub-landing": "Descubra as melhores opções turísticas no Chile com a Outdoor Index. Compare e explore uma ampla variedade de programas do Atacama à Patagônia. Reserve hoje para viver experiências únicas!",
      title: "Tours de aventura no Chile e Patagônia", // Keeping this instead of the original "Aventuras inesquecíveis" to match the 'es' source.
      subtitle: "Encontre aventuras com os melhores guias locais" // Keeping this instead of the original "Explore a natureza" to match the 'es' source.
    },
    guidebook: {
      download_our_guide_book: "Baixe nosso livro guia e comece sua viagem com a Outdoor Index",
      find_out_everything: "Descubra tudo sobre a Patagônia Chilena Sul."
    },
    reviews: {
      title: "Avaliações",
      more: "Mais",
      reviewing_excursion: "Deixe sua avaliação",
      thanks_for_submitting: "Obrigado pela sua avaliação",
      review: "Avaliação",
      footer: "Ver no TrustPilot"
    },
    home: {
      site_title: "Outdoor Index: Reserve tours de aventura na Patagônia e Chile",
      things_to_do_in: "Sugestões em",
      scientific_excursions: "Em profundo contato com a natureza",
      luxury_experience: "Viva exclusivo, só para você",
      adventure_excursions: "Dê mais de si mesmo",
      the_best_excursions: "As melhores excursões para esta temporada",
      explore_your_interests: "Explore seus interesses",
      excursions: "Excursões",
      products: "produtos",
      suggestions: "Sugestões",
      hard_adventurous: "Ativos",
      soft_adventurous: "Transformador",
      scientific: "Descoberta",
      family: "Grupos",
      luxury: "Sofisticados",
      promotions: "Promocionais",
      download: "Download",
      adventures_by_region: "Aventuras por região",
      north_patagonia: "Patagônia Norte",
      south_patagonia: "Patagônia Sul",
      lakes_and_rivers: "Região Lagos e Rios"
    },
    excursions: {
      title: "Título",
      location: "Lugar",
      zone: "Zona",
      category: "Categoria",
      profiles: "Tipo de viagem",
      price: "Preço (em dólares)",
      usd_price: "Preço (em dólares)",
      clp_price: "Preço (em pesos)",
      vacancies: "Vagas",
      duration: "Duração",
      half_day: "Meio dia",
      full_day: "Dia inteiro",
      multiple_days: "Vários dias",
      duration_days: "Dias",
      duration_hours: "Horas",
      itinerary: {
        title: "Título",
        sub_title: "Subtítulo",
        body: "Corpo"
      },
      faq: {
        title: "Título",
        sub_title: "Subtítulo",
        body: "Corpo"
      },
      days: {
        zero: "Dia",
        one: "Dia",
        other: "Dias"
      },
      hours: {
        zero: "Hora",
        one: "Hora",
        other: "Horas"
      },
      "add_images_(minimum_3)": "Adicionar imagens (mínimo 3)",
      disclaimer: "Aviso Legal",
      description: "Visão geral",
      body: "Nosso Itinerário",
      body_old: "Nosso Itinerário (antigo)",
      useful_information: "Informações úteis",
      "what's_included?": "Incluído",
      "what's_not_included?": "Não incluído",
      meeting_instruction: "Local de partida",
      meeting_address: "Endereço",
      policies: "Políticas de cancelamento",
      save_excursion: "Salvar excursão",
      "what_we'll_do": "Visão geral",
      our_itinerary: "Itinerário",
      faqs: "FAQs",
      images: "Imagens",
      edit_excerpt: "Toda a informação solicitada para criar o perfil do fornecedor é de vital importância para estabelecer o vínculo comercial com a Outdoor Index. Por favor, insira a informação o mais precisa possível.",
      other_excursions_from_this_tour_company: "Outras experiências deste fornecedor",
      create_excursions: "Criar excursão",
      more: "Mais",
      less: "Menos",
      best_excursions_for_the_next_season: "Recomendados para esta temporada",
      add_extras: "Adicionar extras",
      price_per_reservations: "Preço por reserva",
      minimum_reservations: "Nº passageiros",
      extra_description: "Atividade",
      mkt_clp_price: "Valor base clp",
      mkt_usd_price: "Valor base usd",
      macro_zone: "Macro Zona",
      meta_title: "Meta título",
      meta_description: "Meta descrição",
      time: "Tempo",
      prices: "Preços",
      details: "Detalhes",
      included: "O que está incluído?",
      locations: "Localização"
    },
    products_show_photos: "Ver (%{n}) fotos",
    ondemand: {
      explanation: "Excursão exclusiva! Entre em contato com nosso especialista local.",
      label: "Privado"
    },
    products_search: {
      activities: "Atividades",
      regions: "Regiões",
      time: "Tempo",
      date_sub_label: "Quando você quer ir?",
      activities_sub_label: "Escolha sua atividade",
      regions_sub_label: "Qual região você quer visitar?",
      time_sub_label: "Selecione sua preferência de horário!",
      date: "Data",
      all_adventures: "Todas as aventuras",
      search: "Procurar",
      clear: "Limpar seleção",
      tours: "tours",
      subtext: "Explore todos os tours e excursões disponíveis. Planeje seu itinerário, reserve e desfrute das maravilhas da nossa naturezar.",
      in: "em"
    },
    searches: {
      no_result_to: 'Desculpe, não há resultados para "%{category_name}" em "%{zone_name}"',
      recommended_for_you: 'Experiências para fazer em "%{zone_name}"',
      category_products_in_zone: '"%{category_name}" em "%{zone_name}"',
      category_products_in_zone_no_result: 'Desculpe, por agora não há "%{category_name}" em "%{zone_name}"',
      all_products_in_zone: 'Todas as experiências em "%{zone_name}"',
      all_products_in_zone_no_result: 'Desculpe, não há experiências em "%{zone_name}"',
      all_category_products: 'Todas as experiências de "%{category_name}"',
      all_category_products_no_result: 'Desculpe, por agora não há experiências de "%{category_name}"',
      please_select_category_or_zone: "Por favor selecione uma categoria ou zona"
    },
    label: "Privado",
    active_admin: {
      landing: {
        more_info: "Mais info"
      }
    },
    blog: {
      travel_nature_growth: "Viagens, natureza & crescimento"
    },
    chat: {
      need_help: 'Precisa de ajuda?',
      talk_to_local_guide: 'Fale com um guia local'
    }
  },
  fr: { // Francés (Corregido)
    from: "À partir de",
    home_collections: {
      home_reviews: "Plus de 350 personnes par an voyagent avec Outdoor Index",
      find_your_experience: "Cherchez votre excursion",
      carousel_region: "Aventures par région",
      carousel_activities: "Aventures par activités",
      carousel_time_preference: "Aventures par préférence horaire",
      "sub-landing": "Découvrez les meilleures options touristiques au Chili avec Outdoor Index. Comparez et explorez une grande variété de programmes de l'Atacama à la Patagonie. Réservez dès aujourd'hui pour vivre des expériences uniques !", // Usar comillas dobles
      title: "Tours d'aventure au Chili et en Patagonie", // Usar comillas dobles
      subtitle: "Trouvez des aventures avec les meilleurs guides locaux"
    },
    guidebook: {
      download_our_guide_book: "Téléchargez notre guide et commencez votre voyage avec Outdoor Index",
      find_out_everything: "Découvrez tout sur la Patagonie Chilienne Sud."
    },
    reviews: {
      title: "Avis",
      more: "Plus",
      reviewing_excursion: "Laissez votre avis",
      thanks_for_submitting: "Merci pour votre avis",
      review: "Avis",
      footer: "Voir sur TrustPilot"
    },
    home: {
      site_title: "Outdoor Index : Réservez des tours d'aventure en Patagonie et au Chili", // Usar comillas dobles
      things_to_do_in: "Suggestions à",
      scientific_excursions: "En contact profond avec la nature",
      luxury_experience: "Vivez exclusif, rien que pour vous",
      adventure_excursions: "Dépassez-vous",
      the_best_excursions: "Les meilleures excursions pour cette saison",
      explore_your_interests: "Explorez vos centres d'intérêt", // Usar comillas dobles
      excursions: "Excursions",
      products: "produits",
      suggestions: "Suggestions",
      hard_adventurous: "Actifs",
      soft_adventurous: "Transformateur",
      scientific: "Découverte",
      family: "Groupes",
      luxury: "Sophistiqués",
      promotions: "Promotionnels",
      download: "Télécharger",
      adventures_by_region: "Aventures par région",
      north_patagonia: "Patagonie Nord",
      south_patagonia: "Patagonie Sud",
      lakes_and_rivers: "Région des Lacs et Rivières"
    },
    excursions: {
      title: "Titre",
      location: "Lieu",
      zone: "Zone",
      category: "Catégorie",
      profiles: "Type de voyage", // Originalmente no tenía, pero podría ser "Type d'..."
      price: "Prix (en dollars)",
      usd_price: "Prix (en dollars)",
      clp_price: "Prix (en pesos)",
      vacancies: "Places",
      duration: "Durée",
      half_day: "Demi-journée",
      full_day: "Journée complète",
      multiple_days: "Plusieurs jours",
      duration_days: "Jours",
      duration_hours: "Heures",
      itinerary: {
        title: "Titre",
        sub_title: "Sous-titre",
        body: "Corps"
      },
      faq: {
        title: "Titre",
        sub_title: "Sous-titre",
        body: "Corps"
      },
      days: {
        zero: "Jour",
        one: "Jour",
        other: "Jours"
      },
      hours: {
        zero: "Heure",
        one: "Heure",
        other: "Heures"
      },
      "add_images_(minimum_3)": "Ajouter des images (minimum 3)",
      disclaimer: "Clause de non-responsabilité", // Usar comillas dobles si lleva apóstrofe
      description: "Aperçu général",
      body: "Notre Itinéraire",
      body_old: "Notre Itinéraire (ancien)",
      useful_information: "Infos utiles",
      "what's_included?": "Inclus",
      "what's_not_included?": "Non inclus",
      meeting_instruction: "Lieu de départ",
      meeting_address: "Adresse",
      policies: "Politiques d'annulation", // Usar comillas dobles
      save_excursion: "Sauvegarder l'excursion", // Usar comillas dobles
      "what_we'll_do": "Aperçu général",
      our_itinerary: "Itinéraire",
      faqs: "FAQs",
      images: "Images",
      edit_excerpt: "Toutes les informations demandées pour créer le profil du fournisseur sont d'une importance vitale pour établir le lien commercial avec Outdoor Index. Veuillez saisir les informations aussi précisément que possible.", // Usar comillas dobles
      other_excursions_from_this_tour_company: "Autres expériences de ce fournisseur", // Usar comillas dobles si lleva apóstrofe
      create_excursions: "Créer une excursion",
      more: "Plus",
      less: "Moins",
      best_excursions_for_the_next_season: "Recommandés pour cette saison",
      add_extras: "Ajouter des extras",
      price_per_reservations: "Prix par réservation",
      minimum_reservations: "N° passagers",
      extra_description: "Activité",
      mkt_clp_price: "Valeur de base clp",
      mkt_usd_price: "Valeur de base usd",
      macro_zone: "Macro Zone",
      meta_title: "Méta titre",
      meta_description: "Méta description",
      time: "Temps",
      prices: "Prix",
      details: "Détails",
      included: "Qu'est-ce qui est inclus ?", // Usar comillas dobles
      locations: "Emplacement"
    },
    products_show_photos: "Voir (%{n}) photos",
    ondemand: {
      explanation: "Excursion exclusive ! Contactez notre spécialiste sur le terrain.", // Usar comillas dobles si lleva apóstrofe
      label: "Privé"
    },
    products_search: {
      activities: "Activités",
      regions: "Régions",
      time: "Temps",
      date_sub_label: "Quand voulez-vous y aller ?",
      activities_sub_label: "Choisissez votre activité", // Usar comillas dobles si lleva apóstrofe
      regions_sub_label: "Quelle région voulez-vous visiter ?",
      time_sub_label: "Sélectionnez votre préférence horaire !", // Usar comillas dobles si lleva apóstrofe
      date: "Date",
      all_adventures: "Toutes les aventures",
      search: "Rechercher",
      clear: "Effacer la sélection",
      tours: "tours",
      subtext: "Explorez tous les tours et excursions disponibles. Planifiez votre itinéraire, réservez et profitez des merveilles de notre nature.", // Usar comillas dobles si lleva apóstrofe
      in: "à"
    },
    searches: {
      no_result_to: "Désolé, aucun résultat trouvé pour \"%{category_name}\" dans \"%{zone_name}\"", // Usar comillas dobles
      recommended_for_you: 'Expériences à faire dans "%{zone_name}"',
      category_products_in_zone: '"%{category_name}" dans "%{zone_name}"',
      category_products_in_zone_no_result: "Désolé, pour l'instant il n'y a pas de \"%{category_name}\" dans \"%{zone_name}\"", // Usar comillas dobles (CORREGIDA)
      all_products_in_zone: 'Toutes les expériences dans "%{zone_name}"',
      all_products_in_zone_no_result: "Désolé, il n'y a pas d'expériences dans \"%{zone_name}\"", // Usar comillas dobles (CORREGIDA)
      all_category_products: 'Toutes les expériences de "%{category_name}"',
      all_category_products_no_result: "Désolé, pour l'instant il n'y a pas d'expériences de \"%{category_name}\"", // Usar comillas dobles (CORREGIDA)
      please_select_category_or_zone: "Veuillez sélectionner une catégorie ou une zone" // Usar comillas dobles si lleva apóstrofe
    },
    label: "Privé",
    active_admin: {
      landing: {
        more_info: "Plus d'infos" // Usar comillas dobles
      }
    },
    blog: {
      travel_nature_growth: "Voyages, nature & croissance"
    },
    chat: {
      need_help: "Besoin d'aide ?",
      talk_to_local_guide: 'Parlez à un guide local'
    }
  },
  de: { // Alemán
    from: "Ab",
    home_collections: {
      home_reviews: "Über 350 Personen pro Jahr reisen mit Outdoor Index",
      find_your_experience: "Finde deine Exkursion",
      carousel_region: "Abenteuer nach Region",
      carousel_activities: "Abenteuer nach Aktivitäten",
      carousel_time_preference: "Abenteuer nach Zeitpräferenz",
      "sub-landing": "Entdecken Sie die besten touristischen Optionen in Chile mit Outdoor Index. Vergleichen und erkunden Sie eine breite Palette von Programmen von Atacama bis Patagonien. Buchen Sie noch heute, um einzigartige Erlebnisse zu erleben!",
      title: "Abenteuertouren in Chile und Patagonien",
      subtitle: "Finden Sie Abenteuer mit den besten lokalen Guides"
    },
    guidebook: {
      download_our_guide_book: "Laden Sie unser Handbuch herunter und beginnen Sie Ihre Reise mit Outdoor Index",
      find_out_everything: "Erfahren Sie alles über Süd-Chilenisches Patagonien."
    },
    reviews: {
      title: "Bewertungen",
      more: "Mehr",
      reviewing_excursion: "Hinterlassen Sie Ihre Bewertung",
      thanks_for_submitting: "Danke für Ihre Bewertung",
      review: "Bewertung",
      footer: "Auf TrustPilot ansehen"
    },
    home: {
      site_title: "Outdoor Index: Buche Abenteuertouren in Patagonien und Chile",
      things_to_do_in: "Vorschläge in",
      scientific_excursions: "In tiefem Kontakt mit der Natur",
      luxury_experience: "Erlebe Exklusivität, nur für dich",
      adventure_excursions: "Gib mehr von dir",
      the_best_excursions: "Die besten Exkursionen für diese Saison",
      explore_your_interests: "Erkunde deine Interessen",
      excursions: "Exkursionen",
      products: "Produkte",
      suggestions: "Vorschläge",
      hard_adventurous: "Aktiv",
      soft_adventurous: "Transformierend",
      scientific: "Entdeckung",
      family: "Gruppen",
      luxury: "Anspruchsvoll",
      promotions: "Werbeaktionen",
      download: "Herunterladen",
      adventures_by_region: "Abenteuer nach Region",
      north_patagonia: "Nord-Patagonien",
      south_patagonia: "Süd-Patagonien",
      lakes_and_rivers: "Seen- und Flussregion"
    },
    excursions: {
      title: "Titel",
      location: "Ort",
      zone: "Zone",
      category: "Kategorie",
      profiles: "Reisetyp",
      price: "Preis (in Dollar)",
      usd_price: "Preis (in Dollar)",
      clp_price: "Preis (in Pesos)",
      vacancies: "Plätze",
      duration: "Dauer",
      half_day: "Halbtags",
      full_day: "Ganztags",
      multiple_days: "Mehrtägig",
      duration_days: "Tage",
      duration_hours: "Stunden",
      itinerary: {
        title: "Titel",
        sub_title: "Untertitel",
        body: "Körper"
      },
      faq: {
        title: "Titel",
        sub_title: "Untertitel",
        body: "Körper"
      },
      days: {
        zero: "Tag",
        one: "Tag",
        other: "Tage"
      },
      hours: {
        zero: "Stunde",
        one: "Stunde",
        other: "Stunden"
      },
      "add_images_(minimum_3)": "Bilder hinzufügen (mindestens 3)",
      disclaimer: "Haftungsausschluss",
      description: "Überblick",
      body: "Unser Reiseplan",
      body_old: "Unser Reiseplan (alt)",
      useful_information: "Nützliche Infos",
      "what's_included?": "Inklusive",
      "what's_not_included?": "Nicht inklusive",
      meeting_instruction: "Abfahrtsort",
      meeting_address: "Adresse",
      policies: "Stornierungsbedingungen",
      save_excursion: "Exkursion speichern",
      "what_we'll_do": "Überblick",
      our_itinerary: "Reiseplan",
      faqs: "FAQs",
      images: "Bilder",
      edit_excerpt: "Alle zur Erstellung des Anbieterprofils angeforderten Informationen sind von entscheidender Bedeutung für die Herstellung der Geschäftsbeziehung mit Outdoor Index. Bitte geben Sie die Informationen so genau wie möglich ein.",
      other_excursions_from_this_tour_company: "Andere Erlebnisse dieses Anbieters",
      create_excursions: "Exkursion erstellen",
      more: "Mehr",
      less: "Weniger",
      best_excursions_for_the_next_season: "Empfohlen für diese Saison",
      add_extras: "Extras hinzufügen",
      price_per_reservations: "Preis pro Reservierung",
      minimum_reservations: "Anz. Passagiere",
      extra_description: "Aktivität",
      mkt_clp_price: "Basiswert CLP",
      mkt_usd_price: "Basiswert USD",
      macro_zone: "Makrozone",
      meta_title: "Meta-Titel",
      meta_description: "Meta-Beschreibung",
      time: "Zeit",
      prices: "Preise",
      details: "Details",
      included: "Was ist inklusive?",
      locations: "Ort"
    },
    products_show_photos: "(%{n}) Fotos anzeigen",
    ondemand: {
      explanation: "Exklusive Exkursion! Kontaktieren Sie unseren Spezialisten vor Ort.",
      label: "Privat"
    },
    products_search: {
      activities: "Aktivitäten",
      regions: "Regionen",
      time: "Zeit",
      date_sub_label: "Wann möchten Sie gehen?",
      activities_sub_label: "Wählen Sie Ihre Aktivität",
      regions_sub_label: "Welche Region möchten Sie besuchen?",
      time_sub_label: "Wählen Sie Ihre Zeitpräferenz!",
      date: "Datum",
      all_adventures: "Alle Abenteuer",
      search: "Suchen",
      clear: "Auswahl löschen",
      tours: "Touren",
      subtext: "Erkunden Sie alle verfügbaren Touren und Exkursionen. Planen Sie Ihre Reiseroute, buchen Sie und genießen Sie die Wunder unserer Natur.",
      in: "in"
    },
    searches: {
      no_result_to: 'Entschuldigung, keine Ergebnisse für "%{category_name}" in "%{zone_name}" gefunden',
      recommended_for_you: 'Erlebnisse zu tun in "%{zone_name}"',
      category_products_in_zone: '"%{category_name}" in "%{zone_name}"',
      category_products_in_zone_no_result: 'Entschuldigung, im Moment gibt es keine "%{category_name}" in "%{zone_name}"',
      all_products_in_zone: 'Alle Erlebnisse in "%{zone_name}"',
      all_products_in_zone_no_result: 'Entschuldigung, es gibt keine Erlebnisse in "%{zone_name}"',
      all_category_products: 'Alle Erlebnisse von "%{category_name}"',
      all_category_products_no_result: 'Entschuldigung, im Moment gibt es keine Erlebnisse von "%{category_name}"',
      please_select_category_or_zone: "Bitte wählen Sie eine Kategorie oder Zone aus"
    },
    label: "Privat",
    active_admin: {
      landing: {
        more_info: "Mehr Infos"
      }
    },
    blog: {
      travel_nature_growth: "Reisen, Natur & Wachstum"
    },
    chat: {
      need_help: 'Benötigen Sie Hilfe?',
      talk_to_local_guide: 'Sprich mit einem lokalen guide'
    }
  }
};

// --- Código existente ---
const rawLocale = document.documentElement.getAttribute("lang")?.toLowerCase() || "en";
const baseLocale = rawLocale.split("-")[0];
I18n.locale = baseLocale;

window.I18n = I18n;

export default I18n;